<template>
    <div>
        <portlet
                :icon="'fal fa-edit'"
                :title="'Afspraak inplannen'"
                :actionsBlock="false"
                :footer="false"
        >
            <template slot="portletBody">
                <template v-if="!candidate.blacklisted">
                    <div class="row">
                        <div class="form-group col-lg-4">
                            <label for="candidateAppointment-customer">Bedrijf</label>
                            <v-select
                                    :options="activeCustomers"
                                    :selectOnTab="true"
                                    id="candidateAppointment-customer"
                                    label="name"
                                    name="customer"
                                    v-validate="'required'"
                                    :closeOnSelect="true"
                                    v-model="candidateAppointment.customerId"
                                    :reduce="getCustomers => getCustomers.id"
                                    :class="{ 'is-invalid': errors.has('customer')}"
                                    :clearable="false"
                                    @search:blur="customerChosen($event)"
                            >
                                <div slot="no-options">Geen bedrijven gevonden</div>
                            </v-select>
                            <span v-if="errors.first('customer')" class="small text-danger">Dit veld is verplicht</span>
                        </div>
                        <div class="form-group col-lg-4">
                            <label for="candidateAppointment-email">E-mailadres</label>
                            <input
                                    name="email"
                                    id="candidateAppointment-email"
                                    type="email"
                                    class="form-control"
                                    data-vv-as="email"
                                    v-validate="'required|email'"
                                    :class="{ 'is-invalid': errors.has('email')}"
                                    v-model="candidateAppointment.email"
                            />
                            <span v-if="errors.first('email')" class="small text-danger">Dit moet een geldig e-mailadres zijn</span>
                        </div>
                        <div class="form-group col-lg-4">
                            <label for="candidateAppointment-contact">Contactpersoon</label>
                            <input
                                    name="email"
                                    id="candidateAppointment-contact"
                                    type="text"
                                    class="form-control"
                                    v-validate="'required'"
                                    :class="{ 'is-invalid': errors.has('contact')}"
                                    v-model="candidateAppointment.contact"
                            />
                            <span v-if="errors.first('contact')" class="small text-danger">Dit veld is verplicht</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 form-group">
                            <label for="candidateAppointment-startDate">Datum afspraak</label>
                            <datepicker
                                    :language="nl"
                                    id="candidateAppointment-startDate"
                                    v-model="candidateAppointment.startDate"
                                    :fullMonthName="true"
                                    format="dd-MM-yyyy"
                                    input-class="form-control"
                                    :calendar-button="true"
                                    :disabled-dates="{ to: minDateAppointment }"
                                    :calendar-button-icon="'far fa-calendar-alt'"
                                    :clear-button="true"
                                    :clear-button-icon="'far fa-times'"
                                    :class="{ 'is-invalid': errors.has('date') }"
                            ></datepicker>
                            <input
                                    v-model="candidateAppointment.startDate"
                                    v-show="false"
                                    v-validate="'required'"
                                    name="date"
                            />
                            <span v-if="errors.first('date')" class="small text-danger">Dit veld is verplicht</span>
                        </div>
                        <div class="col-lg-4 form-group">
                            <label for="candidateAppointment-startTime">Starttijd</label>
                            <input
                                    v-validate="'required'"
                                    name="candidateAppointment-startTime"
                                    id="candidateAppointment-startTime"
                                    type="time"
                                    class="form-control"
                                    v-model="candidateAppointment.startTime"
                                    @blur="calculateEndTime"
                            />
                            <span v-if="errors.first('candidateAppointment-startTime')" class="small text-danger">Dit veld moet een tijd bevatten.</span>
                        </div>
                        <div class="col-lg-4 form-group">
                            <label for="candidateAppointment-endTime">Eindtijd</label>
                            <input
                                    v-validate="'required|endTimeAfterStartTime'"
                                    name="candidateAppointment-endTime"
                                    id="candidateAppointment-endTime"
                                    type="time"
                                    class="form-control"
                                    v-model="candidateAppointment.endTime"
                            />
                            <span v-if="errors.first('candidateAppointment-endTime') == 'endTimeAfterStartTime'"
                                  class="small text-danger">De eindtijd moet later zijn dan de starttijd.</span>
                            <span v-else-if="errors.first('candidateAppointment-endTime')" class="small text-danger">Dit veld moet een tijd bevatten.</span>

                        </div>
                    </div>

                </template>
                <template v-else>
                    <div class="alert alert-danger">Kandidaat staat op blacklist. Hierdoor kan er voor deze kandidaat
                        geen
                        afspraak gemaakt worden.
                    </div>
                </template>
            </template>

        </portlet>
        <portlet
                :icon="'fal fa-address-card'"
                :title="'Gegevens kandidaat'"
                :actionsBlock="false"
                :footer="true"
        >
            <template slot="portletBody">
                <template>
                    <div class="row">
                        <div class="form-group col-lg-4">
                            <label>Voornaam</label><br>
                            {{ candidate.firstName }}
                        </div>
                        <div class="form-group col-lg-4">
                            <label>Achternaam</label><br>
                            {{ candidate.lastName }}
                        </div>
                        <div class="form-group col-lg-4">
                            <label>Telefoonnummer</label><br>
                            {{ candidate.telephone }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-lg-1">
                            <label>Postcode</label><br>
                            {{ candidate.zipcode }}
                        </div>
                        <div class="form-group col-lg-3">
                            <label>Nr.</label><br>
                            {{ candidate.housenumber }}
                        </div>
                        <div class="form-group col-lg-4">
                            <label>Straatnaam</label><br>
                            {{ candidate.street }}
                        </div>
                        <div class="form-group col-lg-4">
                            <label>Woonplaats</label><br>
                            {{ candidate.residence }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-lg-4">
                            <label>E-mailadres</label><br>
                            {{ candidate.email }}
                        </div>
                    </div>
                </template>
            </template>

            <div slot="portletFooter" class="col-12 text-right">
                <button @click="saveCandidateAppointment" type="submit" class="btn btn-primary">
                    <i class="fal fa-save mr-2"></i> Opslaan
                </button>
            </div>
        </portlet>
    </div>

</template>

<script>
    import {mapGetters} from 'vuex';
    import Datepicker from 'vuejs-datepicker';
    import {nl} from 'vuejs-datepicker/dist/locale';
    import {Validator} from 'vee-validate';


    export default {
        props: ['candidateId', 'candidateInfo'],
        components: {
            Datepicker
        },
        data() {
            return {
                nl: nl,
                minDateAppointment: moment().subtract(1, 'day').toDate(),
                renderedComponent: true,
                candidate: null,
                candidateAppointment: {
                    candidateId: null,
                    customerId: null,
                    email: null,
                    startDate: null,
                    startTime: null,
                    endTime: null,
                    contact: null
                },
                candidateAppointmentCopy: null
            };
        },
        computed: {
            ...mapGetters("appointments", ["getCandidateAppointments"]),
            ...mapGetters('candidates', ['getCandidate']),
            ...mapGetters('customers', ['getCustomer', 'getCustomers']),
            ...mapGetters('blacklist', ['checkBlacklist']),
            activeCustomers() {
              return this.getCustomers.filter(c => c.activeCustomer !== false);
            }
        },
        methods: {
            async customerChosen() {
                if (this.candidateAppointment.customerId) {
                    const customer = this.getCustomer(this.candidateAppointment.customerId);
                    if (customer && customer.activeCustomer === false) {
                        this.$toasted.global.failedRequest({ message: 'Dit bedrijf is niet actief. Afspraken inplannen is niet mogelijk.' });
                        this.candidateAppointment.customerId = null;
                        this.candidateAppointment.email = null;
                        this.candidateAppointment.contact = null;
                        return;
                    }
                    const blockAppointment = await this.blockBecauseOfHistoricalAppointment(this.candidateAppointment.customerId);
                    if (!blockAppointment) {
                        let customer = this.getCustomer(this.candidateAppointment.customerId);
                        if ((!this.candidateAppointment.email || this.candidateAppointment.email == customer.email) && (!this.candidateAppointment.contact || this.candidateAppointment.contact == customer.contact)) {
                            this.candidateAppointment.email = customer.email;
                            this.candidateAppointment.contact = customer.contact;
                        } else {
                            return this.$swal({
                                title: 'Contactpersoon gevonden',
                                html: 'Bij het bedrijf dat u selecteerde horen de volgende gegevens:<br><br>Contactpersoon: <strong>' + customer.contact + '</strong>.<br>E-mailadres: <strong>' + customer.email + '</strong>.<br><br> Wilt u de door uw eerder ingevulde contactgegevens veranderen in deze gegevens?',
                                type: 'warning',
                                confirmButtonText: 'Veranderen',
                                showCancelButton: true,
                                cancelButtonText: 'Annuleren',
                                reverseButtons: true
                            }).then((result) => {
                                if (!result.dismiss) {
                                    this.candidateAppointment.email = customer.email;
                                    this.candidateAppointment.contact = customer.contact;
                                }
                            });
                        }
                    }

                }
            },
            async blockBecauseOfHistoricalAppointment(customerId) {
                const appointments = this.getCandidateAppointments(this.candidateId);
                const inHistory = appointments.findIndex(appointment => appointment.customerId === customerId) > -1;
                if (!inHistory) {
                    return false;
                } else {
                    return this.$swal({
                        title: 'Persoon is al eerder voorgesteld',
                        html: 'Bende eigenwijs en ga je toch door?',
                        type: 'warning',
                        confirmButtonText: 'Ja',
                        showCancelButton: true,
                        cancelButtonText: 'Nee',
                        reverseButtons: true
                    }).then((result) => {
                        if (!result.dismiss) {
                            return false;
                        } else {
                            // Reset appointment details to empty
                            this.candidateAppointment = {
                                candidateId: null,
                                customerId: null,
                                email: null,
                                startDate: null,
                                startTime: null,
                                endTime: null,
                                contact: null
                            };
                            return true;
                        }
                    });
                }
            },
            async calculateEndTime() {
                let newTime = moment(`2000-01-01 ${this.candidateAppointment.startTime}`).add(1, 'hour').format('HH:mm');
                this.candidateAppointment.endTime = newTime;
                this.$toasted.global.successRequest({
                    message: 'De eindtijd is geupdated naar ' + newTime
                });
            },
            renderComponent() {
                this.renderedComponent = false;

                this.$nextTick(() => {
                    this.renderedComponent = true;
                });
            },
            saveCandidateAppointment() {
                this.candidateAppointment.candidateId = this.candidateId;

                this.$validator.validate().then(result => {
                    if (result) {
                        this.candidateAppointmentCopy = this.candidateAppointment;
                        this.candidateAppointment.createdBy = this.$store.getters.getUserData;
                        this.candidateAppointment.department = this.$store.getters.getUserData.selectedDepartment;
                        this.$store.dispatch('appointments/set', this.candidateAppointment).then(() => {
                            this.$toasted.global.successRequest({
                                message: 'Afspraak gepland'
                            });

                            this.renderComponent();
                            this.$emit('unsavedChanges', false);
                            this.$router.push({path: '/appointments'});
                        }).catch(() => {
                            this.$toasted.global.failedRequest();
                        });
                    } else {
                        this.$toasted.global.failedFormRequest();
                    }
                });
            }
        },
        watch: {
            candidatePlacement: {
                handler: function (val) {
                    this.$emit('unsavedChanges', JSON.stringify(val) !== JSON.stringify(this.candidateAppointment));
                },
                deep: true
            }
        },
        created() {
            this.candidateAppointmentCopy = JSON.parse(
                JSON.stringify(this.candidateAppointment)
            );
            this.candidate = this.getCandidate(this.candidateId);


            // Let's check if the endtime of the appointment is later than the start time
            Validator.extend('endTimeAfterStartTime', {
                getMessage: field => 'endTimeAfterStartTime',
                validate: value => {
                    return !this.candidateAppointment.startTime || this.candidateAppointment.startTime < value
                }
            });

        }
    };
</script>
